/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planmembershighlight2Inputs */

const en_planmembershighlight2 = /** @type {(inputs: Planmembershighlight2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members and members-only events`)
};

const de_planmembershighlight2 = /** @type {(inputs: Planmembershighlight2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder und Events nur für Mitglieder`)
};

/**
* | output |
* | --- |
* | "Members and members-only events" |
*
* @param {Planmembershighlight2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planmembershighlight2 = /** @type {((inputs?: Planmembershighlight2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planmembershighlight2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planmembershighlight2(inputs)
	return de_planmembershighlight2(inputs)
});
export { planmembershighlight2 as "planMembersHighlight" }